import Tooltip from "components/tooltip";
import { useAuth } from "providers/auth";
import { useImpersonation } from "providers/impersonation";
import { useDictionary } from "hooks/use-dictionary";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button } from "@mui/material";
import IconButton from "components/icon-button";
import ForgetDeviceButton from "./forget-device-button";

const UserButton = () => {
  const { logout, user } = useAuth();
  const { isImpersonating: isImpersonated } = useImpersonation();
  const dict = useDictionary();

  if (!user) {
    return null;
  }

  return (
    <Tooltip
      placement="bottom"
      Popup={({ close, buttonWidth: minWidth }) => (
        <div
          style={{ minWidth }}
          className="bg-white rounded shadow border select-none origin-top animate-in zoom-in-0 p-6"
        >
          <div className=" flex items-center px-4 font-bold text-xl">{dict.common.userRoles[user.role]}</div>
          <div className="flex items-center justify-center px-4">
            {user.firstName} {user.lastName}
          </div>
          <div className="flex flex-col gap-1 pt-8">
            <Button
              variant="contained"
              color="primary"
              className="w-full"
              onClick={() => {
                logout();
                close();
              }}
            >
              {isImpersonated ? dict.common.homeView.endImpersonation : dict.header.logout}
            </Button>
            <ForgetDeviceButton onDone={close} />
          </div>
        </div>
      )}
      Button={() => (
        <IconButton aria-label={dict.common.ariaLabels.userMenu}>
          <LogoutIcon className="text-black" aria-hidden="false" />
        </IconButton>
      )}
    />
  );
};

export default UserButton;
